import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';

import OfficialPage from '../OfficialPage';

import './ToStoreComment.less';

export default class ToStoreComment extends OfficialPage {
  state = {
    goodsId: '',
    commnetType: 0,
    comments: [],
    commentNums: [],
    loadPage: 1
  }

  constructor(props) {
    super(props);
    document.title = '商品评价';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    var goodsId = options.detail,
      franchiseeId = options.franchisee || ''
    this.setData({
      goodsId: goodsId,
      franchiseeId: franchiseeId
    })
    this.getAssessList(0, 1)
  }

  getAssessList = (commnetType, page, append) => {
    var that = this
    app.getAssessList({
      method: 'post',
      data: {
        goods_id: that.data.goodsId,
        idx_arr: {
          idx: 'level',
          idx_value: commnetType
        },
        page: page,
        page_size: 20,
        sub_shop_app_id: this.data.franchiseeId
      },
      success: function (res) {
        var commentArr = res.data
        if (append) {
          commentArr = that.data.comments.concat(commentArr)
        }
        that.setData({
          comments: commentArr,
          commentNums: res.num,
          loadPage: that.data.loadPage + 1
        })
      }
    })
  }
  clickCommentLabel = e => {
    var commentType = e.target.dataset.type,
      data = {}
    data.loadPage = 1
    data.commnetType = commentType
    this.setData(data)
    this.getAssessList(commentType, 1)
  }
  scrollLoadComment = () => {
    this.getAssessList(this.data.commentType, this.data.loadPage, 1)
  }
  clickPlusImages = e => {
    app.previewImage({
      current: e.currentTarget.dataset.src,
      urls: e.currentTarget.dataset.srcarr && JSON.parse(e.currentTarget.dataset.srcarr)
    })
  }

  render() {
    const { showGetUserInfo, commnetType, commentNums, comments } = this.state
    return (
      <div className="official-page to-store-comment">
        <TopNav title="商品评论"/>
        <React.Fragment>
          <div className="comPage-wrap page" id="commentPage">
            <div className="comPage-top-section">
              <div style={convertLineStyleData('border-bottom:1px solid #f4f4f4;')}>
                <label
                  onClick={this.clickCommentLabel}
                  data-type="0"
                  className={
                    'comPage-comment-label ' + (commnetType == 0 ? 'active' : '')
                  }
                >
                  全部
                </label>
                <label
                  onClick={this.clickCommentLabel}
                  data-type="1"
                  className={
                    'comPage-comment-label ' + (commnetType == 1 ? 'active' : '')
                  }
                >
                  好评 (
                  <label className="comPage-positive-comment">
                    {commentNums[1]}
                  </label>
                  )
                </label>
                <label
                  onClick={this.clickCommentLabel}
                  data-type="2"
                  className={
                    'comPage-comment-label ' + (commnetType == 2 ? 'active' : '')
                  }
                >
                  中评 (
                  <label className="comPage-neutral-comment">
                    {commentNums[2]}
                  </label>
                  )
                </label>
                <label
                  onClick={this.clickCommentLabel}
                  data-type="3"
                  className={
                    'comPage-comment-label ' + (commnetType == 3 ? 'active' : '')
                  }
                >
                  差评 (
                  <label className="comPage-negative-comment">
                    {commentNums[3]}
                  </label>
                  )
                </label>
                <label
                  onClick={this.clickCommentLabel}
                  data-type="4"
                  className={
                    'comPage-comment-label ' + (commnetType == 4 ? 'active' : '')
                  }
                >
                  有图 (
                  <label className="comPage-pic-comment">{commentNums[4]}</label>)
                </label>
              </div>
            </div>
            <div className="comPage-bottom-section">
              <ScrollView
                className="comPage-comment-list"
                scroll-y="true"
                bindscrolltolower={this.scrollLoadComment}
              >
                {comments.map((item, index) => {
                  return (
                    <div className="comPage-comment-item" key={index}>
                      <div>
                        <img
                          className="comPage-comment-photo"
                          src={item.buyer_headimgurl}
                        />
                        <span className="comPage-comment-name">
                          {item.buyer_nickname}
                        </span>
                      </div>
                      <span className="comPage-comment-date">
                        {item.add_time}
                      </span>
                      <div className="comPage-comment-content">
                        {item.assess_info.content}
                      </div>
                      {item.assess_info.has_img && (
                        <div className="comPage-comment-pics">
                          {item.assess_info.img_arr.map((imgSrc, index) => {
                            return (
                              <img
                                key={index}
                                src={imgSrc}
                                data-src={imgSrc}
                                data-srcarr={JSON.stringify(item.assess_info.img_arr)}
                                onClick={this.clickPlusImages}
                              />
                            )
                          })}
                        </div>
                      )}
                    </div>
                  )
                })}
              </ScrollView>
            </div>
          </div>
        </React.Fragment>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/to-store-comment/ToStoreComment.jsx